import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from 'core/guards/auth.guard';
import { RootGuard } from 'core/guards/root.guard';
import { PageNotFoundComponent } from 'project/pages/page-not-found/page-not-found.component';
import { AssignedProjectsResolver, NotSawChangelogResolver } from 'project/project-routing.module';
import { RootLayoutComponent } from 'root/root-layout.component';
import { RootStateResolver } from './root-resolvers';

export { RootStateResolver } from './root-resolvers';

const routes: Routes = [
  {
    path: '',
    canActivate: [AuthGuard, RootGuard],
    canActivateChild: [AuthGuard, RootGuard],
    component: RootLayoutComponent,
    resolve: {
      changelog: NotSawChangelogResolver,
      projects: AssignedProjectsResolver,
      state: RootStateResolver,
    },
    children: [
      {
        path: 'managers',
        loadChildren: () => import('./user/user.module').then(m => m.UserModule),
      },
      {
        path: 'invite',
        loadChildren: () => import('./invite/invite.module').then(m => m.InviteModule),
      },
      {
        path: 'extensions',
        loadChildren: () => import('./extensions/extensions.module').then(m => m.ExtensionsModule),
      },
      {
        path: 'integration',
        loadChildren: () => import('./webhooks/webhooks.module').then(m => m.WebhooksModule),
      },
      {
        path: 'association',
        loadChildren: () => import('./association/association.module').then(m => m.AssociationModule),
      },
      {
        path: 'projects',
        loadChildren: () => import('./project/project.module').then(m => m.ProjectModule),
      },
      {
        path: '**',
        component: PageNotFoundComponent,
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class RootRoutingModule {
}
